import { StripedDataGrid, Select as ViewList } from "../../../components/select";
import { itemController, ItemViewProps, mapDispatchToItemProps, mapStateToItemProps } from "../item.controll";
import { Item } from "../item.model";
import { Box, Chip, Paper, Stack, Typography } from "@mui/material";
import { formatMoney } from "../../../services/utils";
import { GridColDef } from "@mui/x-data-grid";
import { connect } from "react-redux";
import { useEffect, useState } from "react";
import Modal from "../../../components/modal";
import store from "../../../store";
import { ListTableView } from "../../../components/listTableView";
import { TabelaPrecoConfig, TabelaPrecoItem } from "../../../data.types";

import { Sell, Warning } from "@mui/icons-material";
import Alerts from "../../../components/alerts/Alerts";

export const getTabelaPrecoAtiva = (tabela: TabelaPrecoItem[]) => {
    if (tabela.length > 0)
        return (
            <Box sx={{ display: "flex", flex: 1, flexDirection: "row" }}>
                {tabela.filter(value => value.ativo).map((tabela, idx) => (
                    <Box key={idx} sx={{ display: "flex", flex: 1, flexDirection: "column", alignContent: "center", justifyContent: "center" }}>
                        <Typography variant="caption">{tabela.descricao}</Typography>
                        <Typography variant="caption">{formatMoney(tabela.valor)}</Typography>
                    </Box>
                ))}
            </Box>
        )
    return <Box sx={{ display: "flex", flex: 1, flexDirection: "row", alignItems: "center" }}><Warning color="warning" /> <Typography>Indefinido</Typography></Box>
}

const columnItensSelect: GridColDef[] = [
    { field: 'codigo', headerName: 'Cód.', flex: 2 },
    { field: 'descricao', headerName: 'Descricão', flex: 4 },
    { field: 'tabela_preco', headerName: 'Preço', flex: 6, renderCell: (prm) => getTabelaPrecoAtiva(prm.value ? prm.value : []) },
]

interface ItemListSelectProps extends ItemViewProps {
    handleItemSelect: (props: { item: Item, tabela: TabelaPrecoItem }) => any
    needTabPreco: boolean
    tabelaPadrao?: TabelaPrecoConfig
    //handleItemDobleClick?: (item: Item) => any
}

function ItemListSelect(props: ItemListSelectProps) {
    const { handleItemSelect, itemActions, itemState, needTabPreco, tabelaPadrao } = props
    const { row, showAlert, msg, status, rows, loadingRows, changeList, showSelectModal, tabela_preco_selected } = itemState
    const { setShowAlert, read, set, setTabelaPrecoSelected } = itemActions
    const [showSelectTabela, setShowSelectTabela] = useState<{ item: Item, showModal: boolean }>({ item: {} as Item, showModal: false })

    //Read esta sendo chamado no view shell em tipoMov
    /*
        useEffect(()=>{},[tabela])
     */

    const handleConfirmarSelect = (item: Item) => {
        if (needTabPreco) {
            if (item.tabela_preco) {
                if (item.tabela_preco.length === 1 && item.convenio_preco && item.convenio_preco.valor_mp_cond.length === 0) {
                    handleItemSelect({
                        item: item,
                        tabela: item.tabela_preco[0]
                    })
                } else {
                    if (tabelaPadrao) {
                        let findTabela = item.tabela_preco.find(tb => tb._id === tabelaPadrao._id)
                        if (findTabela) {
                            handleItemSelect({
                                item: item,
                                tabela: findTabela
                            })
                        } else {
                            setShowSelectTabela({ item: item, showModal: true })    
                        }
                    } else {
                        setShowSelectTabela({ item: item, showModal: true })
                    }
                }
            }

        } else {
            handleItemSelect({
                item: item,
                tabela: {} as TabelaPrecoItem
            })
        }
    }

    return (
        <ViewList
            displayWidth={window.innerWidth}
            title={"Itens"}
            row={row}
            showAlert={showAlert}
            closeAlert={() => setShowAlert(false)}
            msg={msg}
            status={status}
            elevation={1}
            getRowId={(r) => r._id}
            handleOnChange={handleConfirmarSelect}
            actionsOnkeyEnter={handleConfirmarSelect}
            handleDobleClick={handleConfirmarSelect}
            showSearchContainer={true}
            fontSize={16}
            setTextSearch={() => { }}
            textSearch={""}
            fieldSearch={"descricao"}
            columns={columnItensSelect}
            rows={rows}
            loading={loadingRows}
            setRow={set}
            variantToobar="dense"
            buttonNew={{
                show: false,
                onClick: () => { }
            }}
            buttonRefresh={{
                show: true,
                onClick: () => read()
            }}
            ListItemTextPrimary={(row: Item) => <Typography component={"span"}>{row.descricao}</Typography>}
            ListItemTextSecondary={(row: Item) => <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                {row.tabela_preco.map((tab, idx) => (
                    <Box sx={{ display: "flex", flex: 1, flexDirection: "row", justifyContent: "space-between" }}>
                        <Typography component={"span"}>{tab.descricao}</Typography>
                        <Typography component={"span"}>{formatMoney(tab.valor)}</Typography>
                    </Box>
                ))}
            </Box>}
            changeList={changeList}
            ViewBeforeGridList={() => (
                <TabelaPrecoSelectModal
                    item={showSelectTabela.item}
                    confirmar={(row) => handleItemSelect({ item: showSelectTabela.item, tabela: row })}
                    showModal={showSelectTabela.showModal}
                    handleClose={() => setShowSelectTabela({ item: {} as Item, showModal: false })}
                    setShowMsg={itemActions.setShowMsg}
                />
            )}
        />
    )
}


function SelecionarItemModal(props: ItemListSelectProps) {
    const { itemActions, itemState, handleItemSelect } = props
    const { showSelectModal, rows } = itemState
    const { setShowSelectModal } = itemActions

    return (
        <Modal
            component={<ItemListSelect {...props} />}
            handleClose={() => setShowSelectModal(false)}
            open={showSelectModal}
            heigth="auto"
            width="sm"
            handleOnKeyDown={() => { }}
        />
    )
}


export default connect(mapStateToItemProps, mapDispatchToItemProps)(ItemListSelect);
export const ViewItemSelectModal = connect(mapStateToItemProps, mapDispatchToItemProps)(SelecionarItemModal);
export const handleShowSelectItemModal = (set: boolean) => {
    if (itemController.state.rows.length === 0) {
        store.dispatch(itemController.reducer.actions.read({
            fieldsFilter: [
                { fieldName: "ativo", mangoQuery: "$eq", fieldValue: true }
            ],
            indexName: "index_itens_ativo",
        }))
    }
    store.dispatch(itemController.reducer.actions.setShowSelectModal(set));
}

const columnsTabela: GridColDef[] = [
    { field: 'descricao', headerName: 'Tabela', flex: 2 },
    { field: 'valor', headerName: 'Preço', flex: 1, renderCell: (prm) => formatMoney(prm.value) },
]

const meioPagsCondicional = (rows: Array<{ _id: any, descricao: string }>) => {
    console.log("meioPagsCondicional rows", rows);
    let condicao = ""
    rows.map((row, idx) => {
        if (idx === 0)
            condicao = condicao + row.descricao
        else
            condicao = condicao + " | " + row.descricao
    })
    return condicao
}

const columnsValorConvenio: GridColDef[] = [
    { field: 'valor', headerName: 'Valor do convênio', flex: 4, renderCell: (prm) => formatMoney(prm.value) },
    { field: 'mp_condicional', headerName: 'Meio pag. condicional', flex: 8, renderCell: (prm) => prm.value.length === 0 ? "Todos Meios Pag." : meioPagsCondicional(prm.value) },
]
interface TabelaPrecoSelectProps {
    item: Item,
    confirmar: (tabela: TabelaPrecoItem) => any
    showModal: boolean
    handleClose: () => any
    setShowMsg: (msg: string, type: string) => any
}
const TabelaPrecoSelectModal = (props: TabelaPrecoSelectProps) => {
    const { item, confirmar, handleClose, showModal, setShowMsg } = props

    const handleConfirmar = (row: TabelaPrecoItem) => {
        confirmar(row);
        handleClose();
    }

    const List = () => {
        const [convenio, setConvenio] = useState<{ _id: string, descricao: string }>()
        return (
            <Box sx={{ display: "flex", flex: 1, flexDirection: "column" }}>

                <ListTableView
                    title={"Informar Preço"}

                    columns={columnsTabela}
                    rows={item.tabela_preco.filter(value => value.ativo)}
                    fieldId={"_id"}
                    fieldList={{ fieldPrimary: "descricao", fieldSecondary: "_id", fieldSecondaryEnd: "preco" }}
                    handleClick={handleConfirmar}
                    enableDoubleClick={false}
                    showAlert={false}

                    closeAlert={function (): void {
                        throw new Error("Function not implemented.");
                    }}
                    msg={""}
                    status={""}

                    buttonNovo={{
                        show: false,
                        onClick: function (): void {
                            throw new Error("Function not implemented.");
                        },
                        title: ""
                    }}
                    loading={false}
                />

                {item.convenio_preco && item.convenio_preco.convenios.length > 0 && (
                    <Paper elevation={1} sx={{ p: 1 }}>
                        <Typography variant="subtitle2">Convênio</Typography>
                        <Stack display={"flex"} flex={1} direction={"row"}>
                            {item.convenio_preco.convenios.map((con, idx) => (
                                <Chip
                                    key={idx}
                                    label={con.descricao}
                                    onClick={() => setConvenio(con)}

                                    icon={<Sell style={{ color: convenio !== undefined && convenio._id === con._id ? "blue" : "CaptionText" }} />}
                                />
                            ))}
                        </Stack>
                        <StripedDataGrid
                            rows={item.convenio_preco.valor_mp_cond}
                            columns={columnsValorConvenio}
                            getRowId={row => row._id}
                            density={'compact'}
                            style={{ fontSize: '0.875rem' }}
                            hideFooterPagination={true}
                            hideFooter={true}
                            filterMode="client"
                            loading={false}
                            onRowClick={(prm, ev) => {
                                ev.preventDefault();
                                if (convenio?._id) {
                                    let tab: any = {
                                        ...convenio,
                                        ...prm.row,
                                        type: "convenio",
                                        ativo: true,
                                    }
                                    handleConfirmar(tab);
                                } else {
                                    setShowMsg("Selecione o convênio, antes de informar o preço!", "error")
                                }
                            }}
                        />
                    </Paper>

                )}
            </Box>
        )
    }

    return (
        <Modal
            component={<List />}
            handleClose={handleClose}
            open={showModal}
            heigth="auto"
            width="sm"
            handleOnKeyDown={() => { }}

        />
    )
}